import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './styles.css';
import SEO from '../../components/SEO';

// Partner Auth0 Configuration
const PARTNER_CLIENT_ID = process.env.REACT_APP_AUTH0_PARTNER_CLIENT_ID;
const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE || 'https://api.eternavaults.com';

export default function PartnerLogin() {
  const { loginWithRedirect, isLoading, isAuthenticated, user, getAccessTokenSilently } = useAuth0();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const returnTo = searchParams.get('returnTo') || '/partner';

  // Check if user is a partner and redirect if authorized
  useEffect(() => {
    const checkPartnerAccess = async () => {
      if (isAuthenticated && user) {
        try {
          const token = await getAccessTokenSilently({
            audience: AUTH0_AUDIENCE
          });

          const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api-eternavaults.onrender.com';
          
          // Use check-status endpoint (doesn't require role, auto-activates approved partners)
          const checkStatusResponse = await fetch(`${API_BASE_URL}/api/partner/check-status`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });

          if (checkStatusResponse.ok) {
            const checkData = await checkStatusResponse.json();
            if (checkData.isPartner && checkData.partner?.status === 'active') {
              navigate(returnTo);
              return;
            }
          }

          // Fallback: Check Auth0 partner_admin role
          const payload = JSON.parse(atob(token.split('.')[1]));
          const roles = payload['https://eternavaults.com/roles'] || [];
          
          if (roles.includes('partner_admin')) {
            navigate(returnTo);
          } else {
            // User is not a partner
            navigate('/login?error=partner_access_required');
          }
        } catch (error) {
          console.error('Error checking partner access:', error);
        }
      }
    };

    checkPartnerAccess();
  }, [isAuthenticated, user, getAccessTokenSilently, navigate, returnTo]);

  // Redirect to Auth0 login if not authenticated
  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      // Use partner client ID for login
      loginWithRedirect({
        appState: { returnTo: returnTo },
        authorizationParams: {
          redirect_uri: `${window.location.origin}/auth/callback`,
          audience: AUTH0_AUDIENCE
        }
      });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect, returnTo]);

  return (
    <>
      <SEO
        title="Partner Portal Login - EternaVaults"
        description="Partner administrator login for EternaVaults white-label portal"
        noIndex={true}
      />
      <div className="partner-login-bg">
        <div className="partner-login-container">
          <div className="partner-login-brand">
            <h1>Partner Portal</h1>
            <p className="partner-login-tagline">
              EternaVaults Partner Console
            </p>
          </div>
          <div className="partner-login-form" style={{ textAlign: 'center', padding: '2rem' }}>
            <h2>Redirecting to Sign In...</h2>
            <p style={{ color: '#bfa97a', marginTop: '1rem' }}>
              Please wait while we redirect you to the secure login page.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

